import { Tooltip, Typography } from '@mui/joy';
import { Info, Warning } from '@phosphor-icons/react';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { Color, Level } from 'theme/enums';

const PricingDateEndDecorator = () => {
  const { t } = useTranslation();

  return (
    <Tooltip color={Color.WARNING} title={t('tooltipPricingDate')} sx={{ cursor: 'default' }}>
      <Info />
    </Tooltip>
  );
};

interface IProps {
  label?: string;
  placeholder?: string;
  compact?: boolean;
  onChange?: (value: Dayjs | null) => void;
  popperProps?: Record<string, unknown>;
}

export const PricingDateFormField = ({
  label,
  placeholder,
  compact,
  onChange,
  popperProps,
}: IProps) => {
  const { t } = useTranslation();
  const { control, errors, watch } = useFormContext();

  const pricingDateValue = watch('pricingDate');
  const isPricingDateExpired =
    !!pricingDateValue && dayjs(pricingDateValue).isBefore(dayjs(), 'day');

  return (
    <>
      <FormField
        name="pricingDate"
        type={InputType.DATE_INPUT}
        inputProps={{
          control,
          error: errors?.pricingDate,
          label: label === undefined ? t('labelPricingDate') : label,
          minDate: dayjs().add(1, 'day'),
          endDecorator: <PricingDateEndDecorator />,
          placeholder: placeholder || t('placeholderPricingDateCurrent'),
          ...(onChange ? { onChange } : {}),
          ...(popperProps ? { popperProps } : {}),
        }}
      />

      {!compact && isPricingDateExpired && (
        <Typography
          level={Level.BODY_XS}
          color={Color.WARNING}
          startDecorator={<Warning weight="fill" />}
        >
          {t('warningPricingDateExpired')}
        </Typography>
      )}
    </>
  );
};
